/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_GoogleInputs */

const en_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const fr_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const de_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const it_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const ru_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const es_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const zh_cn2_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`谷歌`)
};

const ja_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グーグル`)
};

const hi_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गूगल`)
};

const pt_pt2_voice_manager_provider_google = /** @type {(inputs: Voice_Manager_Provider_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

/**
* | output |
* | --- |
* | "Google" |
*
* @param {Voice_Manager_Provider_GoogleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_google = /** @type {((inputs?: Voice_Manager_Provider_GoogleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_GoogleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_provider_google(inputs)
	if (locale === "de") return de_voice_manager_provider_google(inputs)
	if (locale === "it") return it_voice_manager_provider_google(inputs)
	if (locale === "ru") return ru_voice_manager_provider_google(inputs)
	if (locale === "es") return es_voice_manager_provider_google(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_provider_google(inputs)
	if (locale === "ja") return ja_voice_manager_provider_google(inputs)
	if (locale === "hi") return hi_voice_manager_provider_google(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_provider_google(inputs)
	return en_voice_manager_provider_google(inputs)
});